import { IntlShape } from 'react-intl';
import { FC } from 'react';
import { Common, Operation, PlaceHolder, Validation } from '../static/Messages';
export interface MessageFormatter {
  formatMessage: <T>(component: FC<T>, ...ids: string[]) => string;
  formatCommonMessage: (value: Common) => string;
  formatValidationMessage: (value: Validation) => string;
  formatPlaceholderMessage: (value: PlaceHolder) => string;
  formatHttpMessage: (value: string) => string;
  formatOperationMessage: (value: Operation) => string;
}

export class LocalMessageFormatter implements MessageFormatter {
  private separator = '_';
  private shared = 'Shared';

  private intl: IntlShape;

  constructor(intl: IntlShape) {
    this.intl = intl;
  }

  /**
   * Formats messages used specifically for FC (component). Adds component name as the prefix to message path.
   * @param component
   * @param ids
   */
  public formatMessage = <T>(component: FC<T>, ...ids: string[]): string => {
    return this.formatMessageByPrefix(component.name, ...ids);
  };
  public formatCommonMessage = (value: Common): string => {
    const commonPrefix = this.shared + `_common_`;
    return this.intl.formatMessage({ id: commonPrefix + Common[value] });
  };

  public formatValidationMessage = (value: Validation): string => {
    const validationPrefix = this.shared + `_validation_`;
    return this.intl.formatMessage({ id: validationPrefix + Validation[value] });
  };

  public formatPlaceholderMessage = (value: PlaceHolder): string => {
    const placeholderPrefix = this.shared + `_placeholder_`;
    return this.intl.formatMessage({ id: placeholderPrefix + PlaceHolder[value] });
  };
  public formatHttpMessage = (value: string): string => {
    return this.intl.formatMessage({ id: this.shared + this.separator + value });
  };
  public formatOperationMessage = (value: Operation): string => {
    const operationPrefix = this.shared + `_operation_`;
    return this.intl.formatMessage({ id: operationPrefix + value });
  };

  private formatMessageByPrefix = (prefix: string, ...ids: string[]): string => {
    let _id = prefix;
    ids.forEach((id) => {
      _id = _id + this.separator + id;
    });
    return this.intl.formatMessage({ id: _id });
  };
}
